interface HasUser {
  userId: string;
}

class Authorization {
  private userId: string;

  public constructor(userId: string) {
    this.userId = userId;
  }

  public canAccessEntity = (entity: HasUser): boolean => {
    return entity.userId === this.userId;
  };

  public cannotAccessEntity = (entity: HasUser): boolean => {
    return !this.canAccessEntity(entity);
  };

  public static of = (userId: string): Authorization => {
    return new Authorization(userId);
  };
}

export default Authorization;
